import { render, staticRenderFns } from "./recipe.vue?vue&type=template&id=01a5ca28&scoped=true&"
import script from "./recipe.vue?vue&type=script&lang=js&"
export * from "./recipe.vue?vue&type=script&lang=js&"
import style0 from "./recipe.vue?vue&type=style&index=0&id=01a5ca28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a5ca28",
  null
  
)

export default component.exports